import { AddMerchantFormType } from "../components/forms/AddMerchant";

export const AddMerchantData: AddMerchantFormType = {
  merchant_name: "",
  unit_number: "",
  towerNumber: "",
  leaseID: "",
  zone: "",
  merchant_logo: "",
  merchant_web_logo: "",
  isSponsored: false,
  promo_image: "",
  detail_image: "",
  directory_category: "",
  directory_subcategory: "",
  username: "",
  company_name: "",
  email: "",
  website: "",
  mobile_no: "",
  about_merchant: "",
  password: "",
  confirm_password: "",
  pin: "",
  confirmPin: "",
  opening_hours: "",
  isFeatured: false,
  isParticipating: false,
  hideFromDirectory: false,
  payWithPoints: false,
  HalalCertified: false,
  acceptsVoucher: false,
  earnPoints: false,
  partner: false,
  status: "",
};

export const UpdateMerchantData: AddMerchantFormType = {
  merchant_name: "",
  unit_number: "",
  towerNumber: "",
  leaseID: "",
  zone: "",
  merchant_logo: "",
  merchant_web_logo: "",
  isSponsored: false,
  promo_image: "",
  detail_image: "",
  directory_category: "",
  directory_subcategory: "",
  username: "",
  company_name: "",
  email: "",
  website: "",
  mobile_no: "",
  about_merchant: "",
  password: "",
  confirm_password: "",
  pin: "",
  confirmPin: "",
  opening_hours: "",
  isFeatured: false,
  isParticipating: false,
  hideFromDirectory: false,
  payWithPoints: false,
  HalalCertified: false,
  acceptsVoucher: false,
  earnPoints: false,
  partner: false,
  status: "",
};
